import { renderDateAndTime } from "helpers/DateAndTime";
import { assertNever, assertNotNull } from "helpers/Helpers";
import dayjs from "dayjs";
import React from "react";
import { CalendarIcon } from "components/icons/Icons";
import { BookingStatus } from "generated/types/types";
import { useTranslation } from "react-i18next";

type Properties = {
    bookingDate: Date | null;
    offeredDate: Date | null;
    userRequestedDates: (Date | null)[];
    bookingStatus: BookingStatus;
};

export const BookingDate: React.FC<Properties> = props => {
    const { t } = useTranslation();
    let dateDetails: React.ReactNode;

    switch (props.bookingStatus) {
        case BookingStatus.Confirmed:
            dateDetails = <span>{t("booking_date_on")}{dayjs(props.bookingDate ?? undefined).format(`DD MMM YYYY [${t("date_picker_at")}] HH:mm`)}</span>;
            break;
        case BookingStatus.Cancelled:
        case BookingStatus.Expired: {
            const date = props.bookingDate ?? props.userRequestedDates[0];
            dateDetails = <span>{t("booking_date_on")}{dayjs(date ?? undefined).format("DD MMM YYYY [-] HH:mm")}</span>;
            break;
        }
        case BookingStatus.Declined:
            dateDetails = (
                <div>
                    <span>{t("booking_date_declined")}</span>
                    {props.userRequestedDates[0] ? <span>{renderDateAndTime(props.userRequestedDates[0])}</span> : null}
                    {props.userRequestedDates[1] ? <span>{renderDateAndTime(props.userRequestedDates[1])}</span> : null}
                    {props.userRequestedDates[2] ? <span>{renderDateAndTime(props.userRequestedDates[2])}</span> : null}
                </div>
            );
            break;
        case BookingStatus.AlternativeDateOffered:
            dateDetails = <span>{t("booking_date_alternate_date")}{dayjs(assertNotNull(props.offeredDate)).format(`DD MMM YYYY [${t("date_picker_at")}] HH:mm`)} {t("booking_date_offered")}</span>;
            break;
        case BookingStatus.Received:
            dateDetails = (
                <div>
                    <span>{t("booking_date_requested")}</span>
                    {props.userRequestedDates[0] ? <span>{renderDateAndTime(props.userRequestedDates[0])}</span> : null}
                    {props.userRequestedDates[1] ? <span>{renderDateAndTime(props.userRequestedDates[1])}</span> : null}
                    {props.userRequestedDates[2] ? <span>{renderDateAndTime(props.userRequestedDates[2])}</span> : null}
                </div>
            );
            break;
        default:
            assertNever(props.bookingStatus);
    }

    return (
        <div className="row grey-emphasize section">
            <div className="date-icon">
                <CalendarIcon />
            </div>
            <div className="col centre-text date-text">{dateDetails}</div>
        </div>
    );
};
